import React from 'react';
import styled from 'styled-components';
import { Fields, IFilter } from 'utils/filtros';
import { useDispatch } from 'react-redux';
import { vagasActions, AppTypes } from 'store/ducks';
import _ from 'lodash';

const Input = styled.input`
  border-radius: 35px;
  text-align: center;
  border: none;
  margin: 25px;
  width: 80%;
`;
const SearchBar = () => {
  const dispatch = useDispatch();

  const debouncedSearch = _.debounce(value => {
    dispatch(vagasActions.filtarVagas(IFilter.icontains(Fields.titulo, value)));
    dispatch({ type: AppTypes.SET_VAGAS_LOADING_FiNISHED });
  }, 1000);

  const handleChange = e => {
    const { value } = e.target;
    dispatch({ type: AppTypes.SET_VAGAS_LOADING });
    debouncedSearch(value);
  };

  return <Input type="text" placeholder="Buscar vagas" onChange={handleChange} />;
};

export default SearchBar;
